Alpine.store('posService', {

    services: [],
    blink: null,
    quotation: false,
    normalize: false,
    register_at: null,
    contact: null,
    invoice_taxes: [],
    taxe_items: [],
    pay_items: [],
    pay_with: null,
    taib: null,
    note: null,
    wid: null,
    received: undefined,

    reset() {
        this.services = [];
        this.blink = null;
        this.quotation = false;
        this.normalize = false;
        this.register_at = null;
        this.contact = null;
        this.invoice_taxes = [];
        this.pay_with = 'cash';
        this.taib = null;
        this.note = null;
        this.storage?.persist();
        this.received = undefined;
    },

    formData() {
        const pay_items = this.pay_items || [];
        const pay_with = this.pay_with || (pay_items[0]?.code);

        return {
            services: this.services,
            quotation: this.quotation,
            normalize: this.normalize,
            register_at: this.register_at,
            contact_id: this.contact ? this.contact : null,
            invoice_taxes: this.invoice_taxes,
            contact: this.contact,
            taib: this.taib,
            note: this.note,
            pay_with,
            received: this.getReceived()
        };
    },

    setReceived(evt) {
        this.received = rwsp(evt.target.value);
    },

    getReceived() {
        if (this.received !== undefined) return this.received;
        return this.net;
    },

    get du() {
        let r = this.getReceived();
        let net = this.net;
        if (isNaN(net) || isNaN(r) || !r || !net) return null;
        return net - r;
    },

    isEmpty() {
        return !!(this.services?.length)
    },

    get storage() {
        if (!localStorage) {
            return null;
        }

        let store = this;
        return {
            persist() {
                const data = {
                    services: store.services,
                    quotation: store.quotation,
                    normalize: store.normalize,
                    register_at: store.register_at,
                    contact: store.contact,
                    invoice_taxes: store.invoice_taxes,
                    pay_with: store.pay_with,
                    taib: store.taib,
                    note: store.note,
                    wid: store.wid
                }
                localStorage.setItem('posService_data', JSON.stringify(data))
            },
            data() {
                return JSON.parse(localStorage.getItem('posService_data') || '{}');
            },
            restore(data) {
                if (!data) data = this.data();
                store.services = data.services || [];
                store.quotation = data.quotation ? true : false;
                store.normalize = data.normalize ? true : false;
                store.register_at = data.register_at;
                store.contact = data.contact;
                store.invoice_taxes = data.invoice_taxes || [];
                store.pay_with = data.pay_with;
                store.taib = data.taib;
                store.note = data.note;
            },
            reset() {
                localStorage.removeItem('posService_data');
            }
        }
    },

    prod: function (prod) {
        const store = this;
        return {

            get add() {
                //check if product already exist
                let old = store.services.find(p => p.id == prod.id);
                if (old) old.qte = (old.qte || 1) + 1;

                else {
                    store.services.unshift({
                        id: prod.id,
                        qte: 1,
                        price: prod.price,
                        discount: prod.discount,
                        original: prod
                    });
                }
                store.storage?.persist();
                this.blink();
            },

            get remove() {
                store.services.splice(store.services.indexOf(prod), 1);
                store.storage?.persist();
                return prod;
            },

            blink() {
                store.blink = prod.id;
                setTimeout(() => store.blink = undefined, 500);
            },

            get txo() {
                return store.taxe_items?.find(t => t.code == prod?.original.taxgroup && t.type == "P");
            },

            get ttc() {
                return prod.price * prod.qte;
            },

            get ht() {
                let txo = this.txo;
                if (!txo?.content) return this.ttc;
                return this.ttc * 100 / (100 + txo.content)
            },

            get taxe() {
                return this.ttc - this.ht;
            },

            get discount() {
                if (prod.discount) return this.ht * prod.discount / 100;
                return 0;
            },

            get real_ht() {
                if (!this.discount) return this.ht;
                return this.ht - this.discount;
            },

            get real_taxe() {
                if (!this.discount) return this.taxe;
                let txo = this.txo;
                if (txo?.content) return this.real_ht * txo.content / 100;
                return 0;
            },

            get real_ttc() {
                if (!this.discount) return this.ttc;
                return this.real_ht + this.real_taxe;
            },
        }
    },

    prods: function () {
        let store = this;
        return {
            get ttc() {
                let a = 0;
                store.services.forEach(p => a += store.prod(p).ttc);
                return a;
            },

            get real_ttc() {
                let a = 0;
                store.services.forEach(p => a += store.prod(p).real_ttc);
                return a;
            },

            get ht() {
                let a = 0;
                store.services.forEach(p => a += store.prod(p).ht);
                return a;
            },

            get real_ht() {
                let a = 0;
                store.services.forEach(p => a += store.prod(p).real_ht);
                return a;
            },

            get discount() {
                let a = 0;
                store.services.forEach(p => a += store.prod(p).discount);
                return a;
            }
        }
    },

    taxes: function () {

        let store = this;

        return {
            toggle(taxe) {
                var i = store.invoice_taxes.indexOf(taxe);
                if (i === -1)
                    store.invoice_taxes?.push(taxe);
                else
                    store.invoice_taxes?.splice(i, 1);
            },

            has(id) {
                return !!store.invoice_taxes.find(el => `${el}` === `${id}`);
            },

            invoice(id = null) {

                if (id) {
                    if (!this.has(id)) return 0;
                    const t = store.taxe_items.find(el => el.id == id);
                    if (!t) return 0;
                    return store.prods().real_ht * t.content / 100;
                } else {
                    let a = 0;
                    store.invoice_taxes.forEach(t => {
                        a += this.invoice(t) || 0;
                    })
                    return a;
                }
            },

            get prods() {
                let a = 0;
                store.services.forEach(p => a += store.prod(p).real_taxe);
                return a;
            }

        }
    },

    get net() {
        return this.prods().real_ttc + this.taxes().invoice();
    },

});

Alpine.data('posService', function (initial = {}) {

    return {
        init() {
            const store = this.$store.posService;
            store.taxe_items = initial.taxe_items;
            store.pay_items = initial.pay_items;
            store.register_at = initial.register_at;
            store.wid = initial.wid;

            const old = store.storage?.data();
            if (old.wid != initial.wid) {
                store.storage?.reset();
            } else {
                store.storage?.restore();
            }
        },

        posService_reset() {
            this.$store.posService.reset();
            this.$store.posService.storage.reset();
            $("#posService-s2-contact").val(null).trigger('change');
        },

        posService_submit() {
            const store = this.$store.posService;
            this.$wire.call('save', store.formData());
        }
    }
});
